
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"12","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.882 5.095L6 3.183 5.12 5.095l-2.091.248 1.546 1.43-.41 2.064L6 7.81l1.837 1.028-.41-2.065 1.546-1.429-2.09-.248zm4.2-.845c.361.043.506.49.24.737L8.88 7.245l.648 3.26a.427.427 0 01-.627.456l-2.9-1.624-2.902 1.624a.427.427 0 01-.627-.456l.648-3.26L.68 4.987a.427.427 0 01.239-.737L4.22 3.86 5.613.84a.427.427 0 01.775 0L7.78 3.859l3.302.391z","fill":"#161616"}})])
          )
        }
      }
    